import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=2d05faac&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d05faac')) {
      api.createRecord('2d05faac', component.options)
    } else {
      api.reload('2d05faac', component.options)
    }
    module.hot.accept("./collapse-item.vue?vue&type=template&id=2d05faac&", function () {
      api.rerender('2d05faac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/collapse/src/collapse-item.vue"
export default component.exports